import { levelsScoresColorData } from '../models/heatMapData'

export default function useScoreLevelColor() {


    return (score, Currentstatus = null, data = levelsScoresColorData) => {
        if (Currentstatus != "Completed") {
            if (Currentstatus === "Resubmitted")
                Currentstatus = "Submitted";
            if (Currentstatus == "Rejected")
                Currentstatus = "Started";
            let currenscoreColor = data.find(a => a.status === Currentstatus)
            if (currenscoreColor)
                return currenscoreColor;
        }
        let currenscoreColor = data.find(a => score >= a.minScore && score < a.maxScore)
        if (currenscoreColor)
            return currenscoreColor
        return {}

    }
}